// Settings

import $ from 'jquery'
window.$ = window.jQuery = $

// Globals

import '../elements/_partials/menu.js'
import '../elements/_partials/currency-switcher.js'
import '../elements/_partials/cookie-consent.js'
import '../elements/_partials/scroll-down.js'
import '../elements/_partials/scroll-to-top.js'
import '../elements/_partials/show-more.js'
import '../elements/_partials/tooltip.js'
import '../elements/_partials/modal.js'

// Page specified scripts

import '../elements/accordion/accordion.js'

// Unused scripts

// WIP scripts

// Vue 3 components

import { createApp } from 'vue'

import PlansTable from '../elements/components/dedicated-servers/PlansTable.vue'

createApp({
    components: {
        PlansTable
    }
}).mount('#app')
